import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0be24a56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub-header" }, "Choose media", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GemHeader = _resolveComponent("GemHeader")!
  const _component_GemColorCarousel = _resolveComponent("GemColorCarousel")!
  const _component_Uploader = _resolveComponent("Uploader")!
  const _component_Row = _resolveComponent("Row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_GemHeader, {
      title: "Drop a gem",
      color: _ctx.color
    }, null, 8, ["color"]),
    _createVNode(_component_GemColorCarousel, { onSelectedColorChanged: _ctx.onSelectedColorChanged }, null, 8, ["onSelectedColorChanged"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_Row, { justify: "start" }, {
        default: _withCtx(() => [
          _createVNode(_component_Uploader, {
            modelValue: _ctx.fileList,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
            "max-count": 1,
            "preview-size": 100,
            "after-read": _ctx.afterFileRead
          }, null, 8, ["modelValue", "after-read"])
        ]),
        _: 1
      })
    ])
  ]))
}